import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { AppService } from '../../services/app.service';
import { ChangeDetectionStrategy } from '@angular/core';
import { LoginService } from '../../services/login/login.service';
import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { Usuario } from '../../models/usuario/usuario.model';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { VotacionService } from 'src/app/services/votacion/votacion.service';
import Swal from 'sweetalert2';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { environment } from '../../../environments/environment';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-solicitud-afiliacion',
  templateUrl: '../../pages/solicitud-afiliacion/aprobacion-solicitud-afiliacion.component.html',
  styleUrls: ['../../pages/solicitud-afiliacion/solicitud-afiliacion.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class AprobacionSolicitudAfiliacionComponent implements OnDestroy {

    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    rutAfiliado: string = localStorage.getItem("rutAfiliado")
    jubilado: string = localStorage.getItem("jubilado")
    solicitudDesafiliacion: string = localStorage.getItem("solicitudDesafiliacion")
    rutUsuario: any;
    urlTree: any;
    code: string;
    state: string;
    mostrarCaip: boolean;
    mostrarDatosCargados: boolean;
    cursos: any[]; postulantes: any[];
    rol: string;
    email: string;
    periodoVotaciones:boolean = false;
    fechaInicioVotacion : any;
    fechaFinVotacion: any;    
    respuesta: any = { accessToken: "", responseCode: 0}
    
    afiliado : any= { rutAfiliado:"",sub:"",name:"",nombres:"", idAfiliado: '',email:'', nombreAfiliado: '', apellidoAfiliado: '' };
    data: any = {rutAfiliado:"",nombres:"", idAfiliado:"",email:"",fechaActual:"",accessToken:"",etapa:0,body:''}
    constructor(private router:Router, private escolaridadService:EscolaridadService,
                private authService: MsalService,
                private productosService:ProductosService, private dialog: MatDialog, private appService: AppService, 
                private loginService: LoginService, private afiliacionService: AfiliacionService, 
                private votacionService: VotacionService) { }
               
    ngOnInit(): void
    {
        let vm = this
        this.votacionService.obtieneProductosPorId(12).then
        (
                productos => productos[0].parametros.map(parametro => {
                    
                    if (parametro.descripcion == 'FECHA_INICIO_VOTACION') {
                        vm.fechaInicioVotacion = parametro.valor
                    }
                    if (parametro.descripcion == 'FECHA_FIN_VOTACION') {
                        vm.fechaFinVotacion = parametro.valor
                    }
                
                })
            )
        .catch(error => console.log(error))     
  
        vm.data.etapa=0
        vm.data.rutAfiliado=vm.rutAfiliado
        vm.data.jubilado=vm.jubilado        
        this.data.mostrarDatosCargados = false;       
        vm.urlTree = this.router.parseUrl(this.router.url);

        vm.code = this.urlTree.queryParams['code'];
        vm.state = this.urlTree.queryParams['state'];

      this.afiliacionService.traeFormularioClaveUnica(vm.code,vm.state).then(
        response => {
           vm.respuesta = response
         
            this.afiliacionService.retornaDatosPorToken(vm.respuesta.accessToken).then(
                response => {
                    vm.afiliado = response
                    vm.data.nombres= vm.afiliado.name.nombres[0]+' '+vm.afiliado.name.nombres[1]
                    vm.data.apellidos= vm.afiliado.name.apellidos[0]+' '+vm.afiliado.name.apellidos[1]                   
          
                    if(vm.solicitudDesafiliacion=="true"){
                      let rut= vm.afiliado.RolUnico.numero
                       vm.data.etapa=4
                       this.aprobarDesafiliacionAfiliado(rut)
                       localStorage.setItem("solicitudDesafiliacion", "false");
                       vm.solicitudDesafiliacion="false"
                     /* reenvciar a solicitud de afiliacion */                  
                    }else if(vm.jubilado=="true"){
                      let rut= vm.afiliado.RolUnico.numero
                       vm.data.etapa=3
                      this.loginJubilados(rut)                      
                    }else{
                        vm.data.etapa=2        
                        this.afiliacionService.cargarAfiliadoenRabbit(vm.rutAfiliado).then(
                        response => { 
                          vm.afiliado = response 
                            this.afiliacionService.logoutClaveUnica().then
                            (response => {})
                            .catch(
                                error => {
                                  console.log('ERROR desde clave unica 0:',error)
                                console.log(error)                             
                                }
                            )                        
                        }
                      ).catch(error => {
                        console.log('ERROR desde clave unica 1:',error)
                        vm.data.etapa=1
                      })
                     
                    }
                                
                }
              ).catch(error => {
                console.log('ERROR desde clave unica2:',error)
                console.log(error)
                vm.data.etapa=1
            })
        }
      )
      .catch(error => {
        console.log('ERROR desde clave unica3:',error)
        console.log(error)
        vm.data.etapa=1
    })  
     
    }

    loginJubilados(rut: any)
    { 
      var vm = this;
      vm.data.etapa=3
      this.afiliacionService.logoutClaveUnica().then
      (response => {})
      .catch(
          error => {
          console.log(error)                             
          }
      )     
      this.loginfuncionario(rut);  
      
    }
    loginfuncionario(rut: any)
    {   var vm = this;
       
        this.afiliacionService.pensionadoPorRut(rut).then
        (
          (usuario: Usuario) => 
            {
           
              this.jwtServicios(usuario)
            }
        ) .catch ( error =>
          { 
              console.log(error); 
              vm.openAlertDialog('Ha ocurrido un problema debido a que no se logró obtener el usuario con el rol de Pensionado.', 'btn-dark');            
              vm.router.navigate(['login']); 
          } );
                      
    }

    jwtServicios( usuario: Usuario) {
      let user = `${environment.user}`
      let pass = `${environment.pass}`
      let apiKey = `${environment.apiKey}`
      this.loginService.jwtServicios(user,pass,apiKey).then
      (
          (response: string) => {         
              console.log('response:',response)  
              this.login(usuario, response)               
          }
      )
      .catch
      (
           error =>
              {                  
                  console.log('error2:',error.error.text)
                  let key=error.error.text
                  this.login(usuario, key)
              }
      )
  }

  login(usuario: Usuario, key:string){
    var vm = this;
    localStorage.setItem("nombreUsuario",usuario.apellidoPaterno+ ' ' +usuario.apellidoMaterno + ', ' +usuario.nombres);
    localStorage.setItem("username", usuario.email);    
    localStorage.removeItem("rol");
    vm.loginService.buscaRolesPensionado(usuario.email,key).then
    (
        (response: any) =>
        {
            localStorage.setItem("idUsuario", response.id)
            localStorage.setItem("rutUsuario", response.rut)
            localStorage.setItem("dvUsuario", response.dv)
            localStorage.setItem("jwt", key);
            localStorage.setItem("jubilado", "true");
            localStorage.setItem('refreshed', 'true');   
            response.rol.forEach(rol => 
            {                      
                if(rol.descripcion == "ROLE_AFILIADO")
                {
                    localStorage.setItem("rol", rol.descripcion); 
                }                          
            });        
                            
           //this.appService.setUserLoggedIn(localStorage.getItem("rol"));
           this.appService.setUserLoggedIn("ROLE_AFILIADO");  
           if (!this.periodoVotaciones) {
            vm.router.navigate(['index-jub']); 
          } else {
              this.logicaVotaciones(response.id);                                    
          }     
           
           
        }
    );
  }


  aprobarDesafiliacionAfiliado(rut: any) {
    let vm = this;
  
        this.afiliacionService.aprobarDesafiliacionAfiliado(rut).then
          (
            response => {
              Swal.close();   
              this.afiliacionService.logoutClaveUnica().then
              (response => {})
              .catch(
                  error => {
                  console.log(error)                             
                  }
              )                                  
            }
          )
          .catch
          (
            () => {          
              Swal.close(); 
              this.afiliacionService.logoutClaveUnica().then
              (response => {})
              .catch(
                  error => {
                  console.log(error)                             
                  }
              )                                    
            }
          )           
  }
  
    ngOnDestroy(): void {
    }

    openAlertDialog(mensaje: string, clase: string) {
      this.dialog.open(AlertDialogComponent, {
          data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
      })
  }
   

    solicitar(rut: any)
    {
      var vm = this
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
    
        console.log(rut)
        this.afiliacionService.ingresarSolicitudAfiliacion(rut).then
        (
            response =>
            {
                console.log(response)
                Swal.close();              
            }
        )
        .catch
        (
            () =>
            {
           
            }
        )
    }
 
    casoExitoso()
    {
        this.router.navigate(['/login'])
    }
    casoFallido()
    {
        this.router.navigate(['/solicitud-afiliacion'])
    }

   // Convertir las fechas a objetos Date
   private convertirFecha(fechaStr: string): Date {
    const [dia, mes, anio] = fechaStr.split("-").map(Number);
    return new Date(anio, mes - 1, dia); // Restamos 1 al mes porque los meses en JS van de 0-11
  }
    logicaVotaciones(usuarioId: any)
    {
        var vm = this;
        const fechaInicio = this.convertirFecha(vm.fechaInicioVotacion);
        const fechaFin = this.convertirFecha(vm.fechaFinVotacion);
        // Obtener la fecha actual sin horas/minutos/segundos
        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0);
        if (fechaActual >= fechaInicio && fechaActual <= fechaFin) {
            console.log("La fecha actual está dentro del período de votación.");

            this.votacionService.existeVotacionUsuario(usuarioId)
                .then((response) => {
                    console.log("existeVotoPrevio:", response)
                    if (response == true) {
                        vm.router.navigate(['index-jub']); 
                    } else {
                        vm.router.navigate(['votacion']);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    vm.router.navigate(['index-jub']); 
                });

        } else {
            console.log("Fuera del período de votación.");
            vm.router.navigate(['index-jub']); 
        }     
    }
}
